<template>
  <section>
    <v-toolbar color="#9190b5" dark prominent src="https://picsum.photos/1920/1080?random">
      <template v-slot:img="{ props }">
        <v-img v-bind="props" gradient="to top right, rgba(145,144,181,.7), rgba(25,32,72,.7)"></v-img>
      </template>
      <v-toolbar-title>{{ $route.name }}</v-toolbar-title>
      <v-spacer/>
      <template v-slot:extension>
        <v-text-field hide-details solo-inverted clearable placeholder="Search" dense v-model="study_groups.search"/>
        <v-btn v-if="authUserCourseLeader" small class="ml-3 box-shadow" color="primary"
               @click="$router.push({name: 'Create study group'})"
        >
          Create new
        </v-btn>
      </template>
    </v-toolbar>

<!--    <v-toolbar class="box-shadow">-->
<!--      <v-text-field hide-details solo-inverted clearable autofocus placeholder="Search" dense v-model="study_groups.search"></v-text-field>-->
<!--      <v-btn v-if="authUserCourseLeader" class="ml-3 box-shadow" color="primary" @click="$router.push({name: 'Create study group'})">Create new</v-btn>-->
<!--    </v-toolbar>-->

    <v-container fluid>
      <v-data-iterator :items="study_groups.items" :search="study_groups.search">
        <template v-slot:default="{items}">
          <v-card v-for="(item, idx) in items" :key="idx" class="mb-4 box-shadow" @click="emmitAction(item)">
            <v-list-item three-line>
              <v-list-item-action color="primary">
                <v-badge bottom offset-x="60" offset-y="15"
                         :color="isOpen(item) ? 'success': 'error'"
                         :content="isOpen(item) ? 'OPEN': 'CLOSED'">
                  <v-avatar size="70px" color="primary" class="box-shadow">
                    <v-img :src="require(`@/assets/logo_mini2.png`)"/>
                  </v-avatar>
                </v-badge>
              </v-list-item-action>

              <v-list-item-content>
                <div class="subtitle-2 mb-1">{{ item.name }}
<!--                  <v-badge overlap :color="isOpen(item) ? 'success': 'error'" :content="isOpen(item) ? 'OPEN': 'CLOSED'"></v-badge>-->
                </div>
                <v-list-item-title class="headline mb-1">
                  {{ $moment(item.start_at).format('DD MMMM YYYY') }} - {{ $moment(item.end_at).format('DD MMMM YYYY') }}
                </v-list-item-title>
                <v-list-item-subtitle>

                  <template v-if="profile_type && profile_type === 'aspiringSolicitor' && getUserStudyGroup(item)">
                    <v-chip :color="getItemColor(item)" text-color="white" class="box-shadow">
                      <v-avatar left>
                        <v-icon v-if="getItemStatus(item) === 'approved'">mdi-check-circle</v-icon>
                        <v-icon v-else>mdi-sync-circle</v-icon>
                      </v-avatar>
                      {{ getItemStatus(item) }}
                    </v-chip>
                  </template>
<!--                  {{ $moment() }}-->
                </v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-action>
                <v-progress-circular size="72" color="success" >
                  <v-btn fab class="box-shadow" color="primary" @click="emmitAction(item)">
                    <v-icon  color="white">mdi-login</v-icon>
                  </v-btn>
                </v-progress-circular>
<!--                <v-btn small color="primary" class="box-shadow mt-3" :to="{name: 'Study group', params: {study_group_id: item.id}}">Open</v-btn>-->
              </v-list-item-action>
            </v-list-item>
            <v-divider/>

<!--            <template v-for="(study_sub_group, idx) in item.study_sub_groups">-->
<!--              <pre :key="idx">{{ study_sub_group }}</pre>-->
<!--            </template>-->

<!--            <template v-if="item.study_sub_groups">-->
<!--              <v-list-item>-->
<!--                <v-list-item-content>-->
<!--                  <v-list-item-title>OSCE P1</v-list-item-title>-->
<!--                </v-list-item-content>-->
<!--                <v-list-item-action>-->
<!--                  <template v-for="date in item.study_sub_groups.p1_exam_dates">-->
<!--                    {{ $moment(date).format('DD/MM/YYYY') }},-->
<!--                  </template>-->
<!--                </v-list-item-action>-->
<!--              </v-list-item>-->
<!--              <v-divider/>-->
<!--              <v-list-item>-->
<!--                <v-list-item-content>-->
<!--                  <v-list-item-title>OSCE P2</v-list-item-title>-->
<!--                </v-list-item-content>-->
<!--                <v-list-item-action>-->
<!--                  <template v-for="date in item.study_sub_groups.p2_exam_dates">-->
<!--                    {{ $moment(date).format('DD/MM/YYYY') }},-->
<!--                  </template>-->
<!--                </v-list-item-action>-->
<!--              </v-list-item>-->
<!--            </template>-->
          </v-card>
        </template>
      </v-data-iterator>
    </v-container>



<!--    <v-dialog v-model="selected_item_dialog" @click:outside="closeSelectedItemDialog" max-width="800px">-->
<!--      <v-form @submit="updateSelectedItem">-->
<!--        <v-card>-->
<!--          <v-toolbar dense dark color="primary">-->
<!--            <v-btn icon @click="closeSelectedItemDialog"><v-icon>mdi-close</v-icon></v-btn>-->
<!--            <v-toolbar-title>Settings</v-toolbar-title>-->
<!--          </v-toolbar>-->

<!--          <v-card-text v-if="selected_item">-->
<!--            <v-select label="OSCE P1 exam dates"-->
<!--                      v-model="selected_item.study_sub_group_id"-->
<!--                      :items="selected_item.studyGroup.study_sub_groups"-->
<!--                      item-value="id"-->
<!--                      item-text="p1_exam_dates"-->
<!--                      prepend-icon="mdi-account-group"-->
<!--            >-->
<!--              <template v-slot:item="{ item }">-->
<!--                <span class="font-weight-bold">{{ item.name }} - </span>-->
<!--                <span v-for="(exam_date, idx) in  item.p1_exam_dates" :key="idx" class="mx-1">-->
<!--                      {{ $moment(exam_date).format('DD/MM/YYYY') }},-->
<!--                    </span>-->
<!--              </template>-->

<!--              <template v-slot:selection="{ item }">-->
<!--                <span class="font-weight-bold">{{ item.name }} - </span>-->
<!--                <span v-for="(exam_date, idx) in  item.p1_exam_dates" :key="idx" class="mx-1">-->
<!--                      {{ $moment(exam_date).format('DD/MM/YYYY') }},-->
<!--                    </span>-->
<!--              </template>-->
<!--            </v-select>-->

<!--            <template v-if="selected_item && selected_item.status === 'invited'">-->
<!--              <v-select id="firstQuestion"-->
<!--                        v-model="first_answer"-->
<!--                        :items="first_answer_options"-->
<!--                        :label="first_question"-->
<!--              />-->

<!--              <v-switch label="Is Sunday your day off?" v-model="selected_item.sunday_day_off"/>-->

<!--              <template v-if="first_answer === 'working' || first_answer === 'working_before_exam'">-->
<!--                <v-subheader>Indicate any time off work/studies within your preparation period when you are available for mock sessions 7 days a week</v-subheader>-->
<!--                <date-field v-model="selected_item.training_start" label="From"/>-->
<!--                <date-field v-model="selected_item.training_end" label="Till"/>-->
<!--              </template>-->
<!--            </template>-->

<!--            <template v-else>-->
<!--                <v-subheader>Your preparation period</v-subheader>-->
<!--                <DateField label="From" v-model="selected_item.training_start"/>-->
<!--                <DateField label="Till" v-model="selected_item.training_end"/>-->
<!--            </template>-->

<!--          </v-card-text>-->
<!--          <v-divider/>-->
<!--          <v-card-actions v-if="selected_item && selected_item.status !== 'invited'">-->
<!--            <v-btn color="red" class="box-shadow" dark @click="destroySelectedItem">-->
<!--              Leave-->
<!--            </v-btn>-->
<!--            <v-spacer/>-->
<!--            <v-btn color="primary" class="box-shadow" type="submit">Update</v-btn>-->
<!--          </v-card-actions>-->
<!--          <v-card-actions v-else class="justify-center">-->
<!--            <v-btn color="red" class="box-shadow" dark @click="discardInvite(selected_item)">Discard</v-btn>-->
<!--            <v-btn color="success" class="box-shadow" @click="acceptInvite(selected_item)">Accept</v-btn>-->
<!--          </v-card-actions>-->
<!--        </v-card>-->
<!--      </v-form>-->
<!--    </v-dialog>-->
  </section>
</template>

<script>
// import DateField from "@/components/DateField";
import {mapGetters} from "vuex";

export default {
  components: {
    // DateField
  },
  data: () => ({
    study_groups: {
      headers: [],
      items: [],
      search: '',
    },
    join_study_group_dialog: false,
    join_study_group: null,

    selected_booking: null,
    selected_booking_dialog: false,
    selected_item: null,
    selected_item_dialog: false,

    first_question: 'Please indicate your availability for exam preparation',
    first_answer_options: [
      {
        text: 'I am flexible (freelancer) or I do not work at all and won’t be working until/after the exam',
        value: 'not_working',
      },
      {
        text: 'I work all working days, and will get less than 2 weeks off work before the exam',
        value: 'not_intensive_working',
      },
      {
        text: 'I work all working days, but will get more than 2 weeks off work before the exam',
        value: 'working',
      },
      {
        text: 'I am not working now, but will get back to work closer to the exam time',
        value: 'working_before_exam',
      },
    ],
    first_answer: '',
  }),
  computed: {
    ...mapGetters({
      profile_type: 'getAuthUserProfileType',
      profile_type_label: 'getAuthUserProfileTypeLabel',
      authUserStudyGroups: 'getAuthUserStudyGroups'
    }),
    visitation_type: function () {
      if (this.first_answer === 'working' || this.first_answer === 'working_before_exam') {
        return 'G3'
      }
      return this.first_answer === 'not_working' ? 'G1' : 'G2'
    },
  },
  created() {
    this.loadData()
    this.$store.dispatch('loadAuthUserStudyGroups')
  },
  methods: {
    async loadData() {
      this.study_groups.items = await this.axios.get('api/study-groups').then(({data}) => data.data)
    },
    isOpen(study_group) {
      let open = this.$moment(study_group.recruitment_start)
      let close = this.$moment(study_group.recruitment_end)
      return this.$currentTime().isBetween(open, close)
    },
    emmitAction(item) {
      this.$router.push({name: 'Study group', params: {study_group_id: item.id}})
    },

    getUserStudyGroup(item) {
      if(this.authUserStudyGroups) {
        return this.authUserStudyGroups.find(user_st => user_st.study_group_id === item.id)
      }
    },
    getItemColor(item) {
      let user_study_group = this.getUserStudyGroup(item)
      if(user_study_group && user_study_group.status === 'approved') return 'success'
      return 'primary'
    },
    getItemStatus(item) {
      let user_study_group = this.getUserStudyGroup(item)
      if(user_study_group) return user_study_group.status
    },
    openSelectedItemDialog(item) {
      this.selected_item = item
      this.selected_item_dialog = true
    },
    closeSelectedItemDialog() {
      this.selected_item_dialog = false
      this.selected_item = null
    },
    discardInvite(item) {
      this.axios.put(`api/user/study-groups/${item.id}`, {...item, action: 'discard'}).then(() => {
        this.loadData()
        this.$notify('Success!', 'success')
        this.closeSelectedItemDialog()
      })
    },
    acceptInvite(item) {
      this.axios.put(`api/user/study-groups/${item.id}`, {...item, action: 'approve'}).then(() => {
        this.loadData()
        this.$notify('Success!', 'success')
        this.closeSelectedItemDialog()
      })
    },
    updateSelectedItem(e) {
      e.preventDefault()
      this.app_loading = true
      this.axios.put(`api/user/study-groups/${this.selected_item.id}`, this.selected_item).then(() => {
        this.loadData()
        this.closeSelectedItemDialog()
        this.$notify('Success!', 'success')
      })
          .catch(errors => { this.api_errors = errors.response.data.errors })
        .then(() => {this.app_loading = false})
    },
    destroySelectedItem() {
      this.axios.delete(`api/user/study-groups/${this.selected_item.id}`).then(() => {
        this.loadData()
        this.closeSelectedItemDialog()
        this.$notify('Success!', 'success')
      })
    }
  }
}
</script>